import { Site, Thematique } from '@zeus/index';
import { TActivity, TThematique } from '~/utils/airtable/types/types';
import { activities } from './parsed-data/activities/activities';
import { thematiques } from './parsed-data/thematiques/thematiques';

export function getThematiquesBySite(): TThematique[] {
  return thematiques;
}

export function getActivitiesByThematiquesAndSite(
  site: Site,
  thematique: Thematique
): TActivity[] {
  let _activities: TActivity[] = [];
  _activities = activities.filter(
    (el) =>
      el.site.includes(site.toString()) &&
      el.thematique === thematique.toString()
  );
  return _activities;
}
